export const accountNumberParser = (v?: string) => {
  if (!v) return undefined;
  const allAlphanumericCharacters = v.replace(/[\W_]/g, '');
  const first16Chars = allAlphanumericCharacters.slice(0, 16);
  return first16Chars;
};
